<template>
  <div class="point-detail-content">
    <div class="table-responsive border-0 point-detail-table-wrapper">
      <table class="table align-items-center point-detail-table">
              <thead>
              <tr>
                <th scope="col">{{ $t("general.activity") }}</th>
                <th scope="col">{{ $t("general.points_i_earned") }}</th>
                <th scope="col">{{ $t("general.detail") }}</th>
                <th scope="col">{{ $t("general.date") }}</th>
              </tr>
              </thead>
              <tbody class="list">
              <tr v-for="(item, index) in items" :key="'user_point_detail_history_item_' + index">
                <th scope="row">
                  <div class="media align-items-start">
                    <div class="media-body">
                      <a class="name h6 mb-0 text-sm" href="#">
                        <i :class="item.point_category.icon ? item.point_category.icon : 'uil-award'" class="mr-1"></i>
                        {{ $t(item.point_category.key_name) }}
                      </a>
                    </div>
                  </div>
                </th>
                <td>{{ item.point }} <i class="uil-coins"></i></td>
                <td>{{ item.pointable?.title }}</td>
                <td>{{ formatDate(item.created_at) }}</td>
              </tr>
              </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/az';
import 'moment/locale/tr';
import 'moment/locale/en-gb';

export default {
  name: "PointDetailModal",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatDate(value) {
      return moment(value).locale(this.secureLocalStorage("language")).format('DD MMMM YYYY');
    }
  }
}
</script>

<style scoped>
.point-detail-content {
  min-width: 0;
  width: 100%;
}

.point-detail-table-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.point-detail-table {
  min-width: 560px;
  margin-bottom: 0;
  font-size: 14px;
}

@media (max-width: 576px) {
  .point-detail-table th,
  .point-detail-table td {
    padding: 12px 10px;
    line-height: 1.4;
  }
}
</style>
